@layer settings {
  :root {
    --fdt-core-color-primary-50: #f6f9fd;
    --fdt-core-color-primary-100: #e2dbf0;
    --fdt-core-color-primary-300: #d98cc6;
    --fdt-core-color-primary-500: #d9269d;
    --fdt-core-color-primary-600: #b3007e;
    --fdt-core-color-primary-700: #82175e;
    --fdt-core-color-primary-800: #570f3f;
    --fdt-core-color-secondary-50: #f6f9fd;
    --fdt-core-color-secondary-100: #e2dbf0;
    --fdt-core-color-secondary-300: #d98cc6;
    --fdt-core-color-secondary-500: #d9269d;
    --fdt-core-color-secondary-600: #b3007e;
    --fdt-core-color-secondary-700: #82175e;
    --fdt-core-color-secondary-800: #570f3f;
    --fdt-core-color-neutral-0: #ffffff;
    --fdt-core-color-neutral-50: #f9fafb;
    --fdt-core-color-neutral-100: #e1e8eb;
    --fdt-core-color-neutral-200: #c2d0d6;
    --fdt-core-color-neutral-300: #abb6bb;
    --fdt-core-color-neutral-600: #5c6970;
    --fdt-core-color-neutral-800: #2e3538;
    --fdt-core-color-neutral-1000: #000000;
    --fdt-core-color-system-info-100: #d1f5fa;
    --fdt-core-color-system-info-500: #0dccf2;
    --fdt-core-color-system-info-600: #0aa3c2;
    --fdt-core-color-system-info-700: #087a91;
    --fdt-core-color-system-error-100: #f6d5d5;
    --fdt-core-color-system-error-500: #d92626;
    --fdt-core-color-system-error-600: #ad1f1f;
    --fdt-core-color-system-error-700: #831616;
    --fdt-core-color-system-succes-100: #dfecdf;
    --fdt-core-color-system-succes-500: #59a659;
    --fdt-core-color-system-succes-600: #478547;
    --fdt-core-color-system-succes-700: #366336;
    --fdt-core-color-system-warning-100: #fae8d1;
    --fdt-core-color-system-warning-500: #f2800d;
    --fdt-core-color-system-warning-600: #c2660a;
    --fdt-core-color-system-warning-700: #914d08;
    --fdt-core-color-brand-primary: #b3007e;
    --fdt-core-color-brand-primary-hover: #82175e;
    --fdt-core-color-brand-primary-pressed: #570f3f;
    --fdt-core-color-accent-light: #e2dbf0;
    --fdt-core-color-accent-light-overlay: rgba(226, 219, 240, 0.5);
    --fdt-core-color-accent-dark: #394a59;
    --fdt-core-color-accent-dark-overlay: rgba(57, 74, 89, 0.5);
    --fdt-core-color-gradient: linear-gradient(
      75deg,
      #570f3f 0%,
      #d9269d 30%,
      #570f3f 100%
    );
    --fdt-core-color-typography-heading-display: #b3007e;
    --fdt-core-color-typography-heading-h1: #b3007e;
    --fdt-core-color-typography-heading-h2: #b3007e;
    --fdt-core-color-typography-heading-h3: #b3007e;
    --fdt-core-color-typography-heading-h4: #b3007e;
    --fdt-core-color-typography-heading-h5: #b3007e;
    --fdt-core-color-typography-heading-h6: #b3007e;
    --fdt-core-color-typography-heading-caption: #b3007e;
    --fdt-core-fontfamily-heading: Rubrik;
    --fdt-core-fontfamily-body: Rubrik;
    --fdt-core-heading-display-fontfamily: Rubrik;
    --fdt-core-heading-display-fontweight: 600;
    --fdt-core-heading-display-lineheight: 1.25;
    --fdt-core-heading-display-fontsize: 69px;
    --fdt-core-heading-display-letterspacing: 0%;
    --fdt-core-heading-display-textcase: none;
    --fdt-core-heading-h1-fontfamily: Rubrik;
    --fdt-core-heading-h1-fontweight: 600;
    --fdt-core-heading-h1-lineheight: 1.25;
    --fdt-core-heading-h1-fontsize: 46px;
    --fdt-core-heading-h1-letterspacing: 0%;
    --fdt-core-heading-h1-textcase: none;
    --fdt-core-heading-h2-fontfamily: Rubrik;
    --fdt-core-heading-h2-fontweight: 600;
    --fdt-core-heading-h2-lineheight: 1.25;
    --fdt-core-heading-h2-fontsize: 38px;
    --fdt-core-heading-h2-letterspacing: 0%;
    --fdt-core-heading-h2-textcase: none;
    --fdt-core-heading-h3-fontfamily: Rubrik;
    --fdt-core-heading-h3-fontweight: 500;
    --fdt-core-heading-h3-lineheight: 1.25;
    --fdt-core-heading-h3-fontsize: 32px;
    --fdt-core-heading-h3-letterspacing: 0%;
    --fdt-core-heading-h3-textcase: none;
    --fdt-core-heading-h4-fontfamily: Rubrik;
    --fdt-core-heading-h4-fontweight: 500;
    --fdt-core-heading-h4-lineheight: 1.25;
    --fdt-core-heading-h4-fontsize: 25px;
    --fdt-core-heading-h4-letterspacing: 0%;
    --fdt-core-heading-h4-textcase: none;
    --fdt-core-heading-h5-fontfamily: Rubrik;
    --fdt-core-heading-h5-fontweight: 500;
    --fdt-core-heading-h5-lineheight: 1.25;
    --fdt-core-heading-h5-fontsize: 21px;
    --fdt-core-heading-h5-letterspacing: 0%;
    --fdt-core-heading-h5-textcase: none;
    --fdt-core-heading-h6-fontfamily: Rubrik;
    --fdt-core-heading-h6-fontweight: 500;
    --fdt-core-heading-h6-lineheight: 1.25;
    --fdt-core-heading-h6-fontsize: 17px;
    --fdt-core-heading-h6-letterspacing: 0%;
    --fdt-core-heading-h6-textcase: none;
    --fdt-core-heading-caption-fontfamily: Rubrik;
    --fdt-core-heading-caption-fontweight: 700;
    --fdt-core-heading-caption-lineheight: 1.25;
    --fdt-core-heading-caption-fontsize: 13px;
    --fdt-core-heading-caption-letterspacing: 5%;
    --fdt-core-heading-caption-textcase: uppercase;
    --fdt-core-fontweight-light: 300;
    --fdt-core-fontweight-regular: 400;
    --fdt-core-fontweight-medium: 500;
    --fdt-core-fontweight-semi-bold: 600;
    --fdt-core-fontweight-bold: 700;
    --fdt-core-fontweight-extra-bold: 800;
    --fdt-core-fontweight-heavy: 900;
    --fdt-core-fontweight-italic: Italic;
    --fdt-core-fontsize-1: 13px;
    --fdt-core-fontsize-2: 15px;
    --fdt-core-fontsize-3: 17px;
    --fdt-core-fontsize-4: 21px;
    --fdt-core-fontsize-5: 25px;
    --fdt-core-fontsize-6: 32px;
    --fdt-core-fontsize-7: 38px;
    --fdt-core-fontsize-8: 46px;
    --fdt-core-fontsize-9: 69px;
    --fdt-core-fontsize-scale: 1.225;
    --fdt-core-fontsize-base: 16px;
    --fdt-core-fontsize-modifier: 1.05;
    --fdt-core-lineheight-heading: 1.25;
    --fdt-core-lineheight-paragraph: 1.5;
    --fdt-core-letterspacing-small: 0%;
    --fdt-core-letterspacing-normal: 5%;
    --fdt-core-letterspacing-wide: 10%;
    --fdt-core-body-p-large-fontfamily: Rubrik;
    --fdt-core-body-p-large-fontweight: 400;
    --fdt-core-body-p-large-lineheight: 1.5;
    --fdt-core-body-p-large-fontsize: 21px;
    --fdt-core-body-p-large-letterspacing: 0%;
    --fdt-core-body-p-normal-fontfamily: Rubrik;
    --fdt-core-body-p-normal-fontweight: 400;
    --fdt-core-body-p-normal-lineheight: 1.5;
    --fdt-core-body-p-normal-fontsize: 17px;
    --fdt-core-body-p-normal-letterspacing: 0%;
    --fdt-core-body-p-small-fontfamily: Rubrik;
    --fdt-core-body-p-small-fontweight: 400;
    --fdt-core-body-p-small-lineheight: 1.5;
    --fdt-core-body-p-small-fontsize: 15px;
    --fdt-core-body-p-small-letterspacing: 0%;
    --fdt-core-body-p-tiny-fontfamily: Rubrik;
    --fdt-core-body-p-tiny-fontweight: 400;
    --fdt-core-body-p-tiny-lineheight: 1.5;
    --fdt-core-body-p-tiny-fontsize: 13px;
    --fdt-core-body-p-tiny-letterspacing: 0%;
    --fdt-core-spacing-1: 4px;
    --fdt-core-spacing-2: 8px;
    --fdt-core-spacing-3: 16px;
    --fdt-core-spacing-4: 24px;
    --fdt-core-spacing-5: 32px;
    --fdt-core-spacing-6: 40px;
    --fdt-core-spacing-7: 48px;
    --fdt-core-spacing-8: 56px;
    --fdt-core-spacing-9: 64px;
    --fdt-core-borderradius-square: 0px;
    --fdt-core-borderradius-tiny: 2px;
    --fdt-core-borderradius-small: 4px;
    --fdt-core-borderradius-medium: 8px;
    --fdt-core-borderradius-large: 16px;
    --fdt-core-borderradius-circle: 9999px;
    --fdt-core-size-icon-micro: 16px;
    --fdt-core-size-icon-tiny: 20px;
    --fdt-core-size-icon-small: 24px;
    --fdt-core-size-icon-normal: 32px;
    --fdt-core-size-icon-large: 40px;
    --fdt-core-size-icon-display: 64px;
    --fdt-core-opacity-soft: 10%;
    --fdt-core-opacity-normal: 50%;
    --fdt-core-opacity-hard: 80%;
    --fdt-core-elevation-1-x: 2px;
    --fdt-core-elevation-1-y: 2px;
    --fdt-core-elevation-1-blur: 5px;
    --fdt-core-elevation-1-spread: 0px;
    --fdt-core-elevation-1-color: rgba(79, 100, 113, 0.05);
    --fdt-core-elevation-1-type: dropShadow;
    --fdt-core-elevation-2-x: 0px;
    --fdt-core-elevation-2-y: 4px;
    --fdt-core-elevation-2-blur: 8px;
    --fdt-core-elevation-2-spread: 0px;
    --fdt-core-elevation-2-color: rgba(0, 0, 0, 0.12);
    --fdt-core-elevation-2-type: dropShadow;
    --fdt-core-elevation-3-x: 0px;
    --fdt-core-elevation-3-y: 8px;
    --fdt-core-elevation-3-blur: 16px;
    --fdt-core-elevation-3-spread: 0px;
    --fdt-core-elevation-3-color: rgba(0, 0, 0, 0.12);
    --fdt-core-elevation-3-type: dropShadow;
    --fdt-core-elevation-4-x: 0px;
    --fdt-core-elevation-4-y: 16px;
    --fdt-core-elevation-4-blur: 32px;
    --fdt-core-elevation-4-spread: 0px;
    --fdt-core-elevation-4-color: rgba(0, 0, 0, 0.12);
    --fdt-core-elevation-4-type: dropShadow;
    --fdt-semantic-opacity-backdrop: 10%;
    --fdt-semantic-opacity-image-overlay: 50%;
    --fdt-semantic-color-foreground-default: #2e3538;
    --fdt-semantic-color-foreground-subtle: #5c6970;
    --fdt-semantic-color-foreground-subtle-hover: #2e3538;
    --fdt-semantic-color-foreground-subtle-pressed: #000000;
    --fdt-semantic-color-foreground-primary: #b3007e;
    --fdt-semantic-color-foreground-pictogram: #b3007e;
    --fdt-semantic-color-foreground-active: #b3007e;
    --fdt-semantic-color-foreground-hover: #82175e;
    --fdt-semantic-color-foreground-pressed: #570f3f;
    --fdt-semantic-color-foreground-inactive: #abb6bb;
    --fdt-semantic-color-foreground-error: #d92626;
    --fdt-semantic-color-foreground-succes: #59a659;
    --fdt-semantic-color-foreground-warning: #c2660a;
    --fdt-semantic-color-foreground-inverted: #ffffff;
    --fdt-semantic-color-foreground-inverted-subtle: #e1e8eb;
    --fdt-semantic-color-foreground-on-brand: #ffffff;
    --fdt-semantic-color-foreground-dark-accent: #394a59;
    --fdt-semantic-color-border-default: #c2d0d6;
    --fdt-semantic-color-border-subtle: #e1e8eb;
    --fdt-semantic-color-border-hover: #abb6bb;
    --fdt-semantic-color-border-inactive: #e1e8eb;
    --fdt-semantic-color-border-primary: #b3007e;
    --fdt-semantic-color-border-active: #b3007e;
    --fdt-semantic-color-border-focus: #d98cc6;
    --fdt-semantic-color-border-error: #d92626;
    --fdt-semantic-color-border-succes: #59a659;
    --fdt-semantic-color-border-warning: #f2800d;
    --fdt-semantic-color-border-inverted: #ffffff;
    --fdt-semantic-color-border-inverted-subtle: rgba(255, 255, 255, 0.2);
    --fdt-semantic-color-border-on-brand: #ffffff;
    --fdt-semantic-color-background-default: #ffffff;
    --fdt-semantic-color-background-neutral: #e1e8eb;
    --fdt-semantic-color-background-subtle: #f9fafb;
    --fdt-semantic-color-background-subtle-hover: #e1e8eb;
    --fdt-semantic-color-background-subtle-pressed: #c2d0d6;
    --fdt-semantic-color-background-primary: #b3007e;
    --fdt-semantic-color-background-primary-hover: #82175e;
    --fdt-semantic-color-background-primary-pressed: #570f3f;
    --fdt-semantic-color-background-primary-light: #e2dbf0;
    --fdt-semantic-color-background-primary-subtle: #f6f9fd;
    --fdt-semantic-color-background-secondary: #d9269d;
    --fdt-semantic-color-background-secondary-hover: #b3007e;
    --fdt-semantic-color-background-secondary-pressed: #82175e;
    --fdt-semantic-color-background-secondary-light: #e2dbf0;
    --fdt-semantic-color-background-secondary-subtle: #f6f9fd;
    --fdt-semantic-color-background-inactive: #f9fafb;
    --fdt-semantic-color-background-error: #d92626;
    --fdt-semantic-color-background-error-light: #f6d5d5;
    --fdt-semantic-color-background-success: #59a659;
    --fdt-semantic-color-background-success-light: #dfecdf;
    --fdt-semantic-color-background-warning: #f2800d;
    --fdt-semantic-color-background-warning-light: #fae8d1;
    --fdt-semantic-color-background-accent-light: #e2dbf0;
    --fdt-semantic-color-background-accent-dark: #394a59;
    --fdt-semantic-color-background-neutral-dark: #2e3538;
    --fdt-semantic-color-primary-50: #f6f9fd;
    --fdt-semantic-color-primary-100: #e2dbf0;
    --fdt-semantic-color-primary-300: #d98cc6;
    --fdt-semantic-color-primary-500: #d9269d;
    --fdt-semantic-color-primary-600: #b3007e;
    --fdt-semantic-color-primary-700: #82175e;
    --fdt-semantic-color-primary-800: #570f3f;
    --fdt-semantic-color-brand-primary: #b3007e;
    --fdt-semantic-color-brand-primary-hover: #82175e;
    --fdt-semantic-color-brand-primary-pressed: #570f3f;
    --fdt-semantic-color-typography-heading-display: #b3007e;
    --fdt-semantic-color-typography-heading-h1: #b3007e;
    --fdt-semantic-color-typography-heading-h2: #b3007e;
    --fdt-semantic-color-typography-heading-h3: #b3007e;
    --fdt-semantic-color-typography-heading-h4: #b3007e;
    --fdt-semantic-color-typography-heading-h5: #b3007e;
    --fdt-semantic-color-typography-heading-h6: #b3007e;
    --fdt-semantic-color-typography-heading-caption: #b3007e;
    --fdt-semantic-color-accent-dark: #394a59;
    --fdt-semantic-borderwidth-default: 1px;
    --fdt-semantic-borderwidth-strong: 2px;
    --fdt-semantic-borderwidth-focus: 4px;
    --fdt-semantic-typography-label-fontfamily: Rubrik;
    --fdt-semantic-typography-label-fontweight: 500;
    --fdt-semantic-typography-label-lineheight: 1.25;
    --fdt-semantic-typography-label-fontsize: 17px;
    --fdt-semantic-typography-label-letterspacing: 0%;
    --fdt-semantic-typography-label-large-fontfamily: Rubrik;
    --fdt-semantic-typography-label-large-fontweight: 500;
    --fdt-semantic-typography-label-large-lineheight: 1.25;
    --fdt-semantic-typography-label-large-fontsize: 21px;
    --fdt-semantic-typography-label-large-letterspacing: 0%;
    --fdt-semantic-typography-label-small-fontfamily: Rubrik;
    --fdt-semantic-typography-label-small-fontweight: 500;
    --fdt-semantic-typography-label-small-lineheight: 1.25;
    --fdt-semantic-typography-label-small-fontsize: 15px;
    --fdt-semantic-typography-label-small-letterspacing: 0%;
    --fdt-semantic-typography-label-tiny-fontfamily: Rubrik;
    --fdt-semantic-typography-label-tiny-fontweight: 500;
    --fdt-semantic-typography-label-tiny-lineheight: 1.25;
    --fdt-semantic-typography-label-tiny-fontsize: 13px;
    --fdt-semantic-typography-label-tiny-letterspacing: 0%;
    --fdt-semantic-typography-description-fontfamily: Rubrik;
    --fdt-semantic-typography-description-fontweight: 400;
    --fdt-semantic-typography-description-lineheight: 1.5;
    --fdt-semantic-typography-description-fontsize: 13px;
    --fdt-semantic-typography-description-letterspacing: 0%;
    --fdt-semantic-typography-placeholder-fontfamily: Rubrik;
    --fdt-semantic-typography-placeholder-fontweight: 400;
    --fdt-semantic-typography-placeholder-lineheight: 1.5;
    --fdt-semantic-typography-placeholder-fontsize: 17px;
    --fdt-semantic-typography-placeholder-letterspacing: 0%;
    --fdt-semantic-typography-intro-fontfamily: Rubrik;
    --fdt-semantic-typography-intro-fontweight: 400;
    --fdt-semantic-typography-intro-lineheight: 1.5;
    --fdt-semantic-typography-intro-fontsize: 21px;
    --fdt-semantic-typography-intro-letterspacing: 0%;
    --fdt-semantic-typography-quote-fontfamily: Rubrik;
    --fdt-semantic-typography-quote-fontweight: 500;
    --fdt-semantic-typography-quote-lineheight: 1.25;
    --fdt-semantic-typography-quote-fontsize: 32px;
    --fdt-semantic-typography-quote-letterspacing: 0%;
    --fdt-semantic-typography-quote-textcase: none;
    --fdt-semantic-size-checkbox: 20px;
    --fdt-semantic-size-radio: 20px;
    --fdt-semantic-link: underline;
    --fdt-semantic-emphasize: 600;
    --fdt-semantic-borderradius-checkbox: 4px;
    --fdt-semantic-borderradius-card: 4px;
    --fdt-semantic-borderradius-radio: 9999px;
    --fdt-semantic-borderradius-field: 4px;
    --fdt-semantic-borderradius-tag: 16px;
    --fdt-semantic-borderradius-badge: 4px;
    --fdt-semantic-borderradius-modal: 8px;
    --fdt-semantic-fontfamily-heading: Rubrik;
    --fdt-semantic-fontfamily-body: Rubrik;
    --fdt-semantic-heading-display-fontfamily: Rubrik;
    --fdt-semantic-heading-display-fontweight: 600;
    --fdt-semantic-heading-display-lineheight: 1.25;
    --fdt-semantic-heading-display-fontsize: 69px;
    --fdt-semantic-heading-display-letterspacing: 0%;
    --fdt-semantic-heading-h1-fontfamily: Rubrik;
    --fdt-semantic-heading-h1-fontweight: 600;
    --fdt-semantic-heading-h1-lineheight: 1.25;
    --fdt-semantic-heading-h1-fontsize: 46px;
    --fdt-semantic-heading-h1-letterspacing: 0%;
    --fdt-semantic-heading-h2-fontfamily: Rubrik;
    --fdt-semantic-heading-h2-fontweight: 600;
    --fdt-semantic-heading-h2-lineheight: 1.25;
    --fdt-semantic-heading-h2-fontsize: 38px;
    --fdt-semantic-heading-h2-letterspacing: 0%;
    --fdt-semantic-heading-h3-fontfamily: Rubrik;
    --fdt-semantic-heading-h3-fontweight: 500;
    --fdt-semantic-heading-h3-lineheight: 1.25;
    --fdt-semantic-heading-h3-fontsize: 32px;
    --fdt-semantic-heading-h3-letterspacing: 0%;
    --fdt-semantic-heading-h4-fontfamily: Rubrik;
    --fdt-semantic-heading-h4-fontweight: 500;
    --fdt-semantic-heading-h4-lineheight: 1.25;
    --fdt-semantic-heading-h4-fontsize: 25px;
    --fdt-semantic-heading-h4-letterspacing: 0%;
    --fdt-semantic-heading-h5-fontfamily: Rubrik;
    --fdt-semantic-heading-h5-fontweight: 500;
    --fdt-semantic-heading-h5-lineheight: 1.25;
    --fdt-semantic-heading-h5-fontsize: 21px;
    --fdt-semantic-heading-h5-letterspacing: 0%;
    --fdt-semantic-heading-h6-fontfamily: Rubrik;
    --fdt-semantic-heading-h6-fontweight: 500;
    --fdt-semantic-heading-h6-lineheight: 1.25;
    --fdt-semantic-heading-h6-fontsize: 17px;
    --fdt-semantic-heading-h6-letterspacing: 0%;
    --fdt-semantic-heading-caption-fontfamily: Rubrik;
    --fdt-semantic-heading-caption-fontweight: 700;
    --fdt-semantic-heading-caption-lineheight: 1.25;
    --fdt-semantic-heading-caption-fontsize: 13px;
    --fdt-semantic-heading-caption-letterspacing: 5%;
    --fdt-button-color-primary-background: #b3007e;
    --fdt-button-color-primary-background-hover: #82175e;
    --fdt-button-color-primary-background-pressed: #570f3f;
    --fdt-button-color-primary-text: #ffffff;
    --fdt-button-color-primary-background-inverted: #ffffff;
    --fdt-button-color-primary-background-hover-inverted: #f6f9fd;
    --fdt-button-color-primary-background-pressed-inverted: #e2dbf0;
    --fdt-button-color-primary-text-inverted: #b3007e;
    --fdt-button-color-primary-background-on-brand: #ffffff;
    --fdt-button-color-primary-background-hover-on-brand: #f6f9fd;
    --fdt-button-color-primary-background-pressed-on-brand: #e2dbf0;
    --fdt-button-color-primary-text-on-brand: #b3007e;
    --fdt-button-color-secondary-background-hover: rgba(179, 0, 126, 0.1);
    --fdt-button-color-secondary-background-pressed: rgba(179, 0, 126, 0.25);
    --fdt-button-color-secondary-foreground: #b3007e;
    --fdt-button-color-secondary-foreground-hover: #82175e;
    --fdt-button-color-secondary-foreground-pressed: #570f3f;
    --fdt-button-color-secondary-border: #b3007e;
    --fdt-button-color-secondary-border-inverted: #ffffff;
    --fdt-button-color-secondary-border-on-brand: #ffffff;
    --fdt-button-color-secondary-background-hover-inverted: rgba(
      255,
      253,
      253,
      0.05
    );
    --fdt-button-color-secondary-background-pressed-inverted: rgba(
      255,
      255,
      255,
      0.1
    );
    --fdt-button-color-secondary-foreground-inverted: #ffffff;
    --fdt-button-color-secondary-background-hover-on-brand: rgba(
      255,
      253,
      253,
      0.05
    );
    --fdt-button-color-secondary-background-pressed-on-brand: rgba(
      255,
      255,
      255,
      0.1
    );
    --fdt-button-color-secondary-foreground-on-brand: #ffffff;
    --fdt-button-color-tertiary-background: #f9fafb;
    --fdt-button-color-tertiary-background-inverted: rgba(255, 255, 255, 0.05);
    --fdt-button-color-tertiary-border-inverted: rgba(255, 255, 255, 0.05);
    --fdt-button-color-tertiary-border: #f9fafb;
    --fdt-button-color-tertiary-background-hover: #e1e8eb;
    --fdt-button-color-tertiary-background-hover-inverted: rgba(
      255,
      255,
      255,
      0.1
    );
    --fdt-button-color-tertiary-border-hover-inverted: rgba(255, 255, 255, 0.1);
    --fdt-button-color-tertiary-border-hover: #e1e8eb;
    --fdt-button-color-tertiary-background-pressed: #c2d0d6;
    --fdt-button-color-tertiary-background-pressed-inverted: rgba(
      255,
      255,
      255,
      0.15
    );
    --fdt-button-color-tertiary-border-pressed: #c2d0d6;
    --fdt-button-color-tertiary-foreground: #b3007e;
    --fdt-button-color-tertiary-foreground-hover: #82175e;
    --fdt-button-color-tertiary-foreground-pressed: #570f3f;
    --fdt-button-color-tertiary-text: #2e3538;
    --fdt-button-color-tertiary-text-inverted: #fff;
    --fdt-button-color-disabled-border: #e1e8eb;
    --fdt-button-color-disabled-background: #f9fafb;
    --fdt-button-color-disabled-text: #abb6bb;
    --fdt-button-color-disabled-border-inverted: rgba(255, 255, 255, 0.15);
    --fdt-button-color-disabled-background-inverted: rgba(255, 255, 255, 0.15);
    --fdt-button-color-disabled-text-inverted: rgba(255, 255, 255, 0.4);
    --fdt-button-color-focus-border: #d98cc6;
    --fdt-button-color-destructive-background: #d92626;
    --fdt-button-color-destructive-background-hover: #ad1f1f;
    --fdt-button-color-destructive-background-pressed: #831616;
    --fdt-button-borderwidth-button: 1px;
    --fdt-button-borderwidth-button-focus: 4px;
    --fdt-button-borderradius-button: 4px;
    --fdt-button-typography-button-label-fontfamily: Rubrik;
    --fdt-button-typography-button-label-fontweight: 500;
    --fdt-button-typography-button-label-lineheight: 1.25;
    --fdt-button-typography-button-label-fontsize: 17px;
    --fdt-button-typography-button-label-letterspacing: 0%;
    --fdt-button-typography-button-label-small-fontfamily: Rubrik;
    --fdt-button-typography-button-label-small-fontweight: 500;
    --fdt-button-typography-button-label-small-lineheight: 1.25;
    --fdt-button-typography-button-label-small-fontsize: 15px;
    --fdt-button-typography-button-label-small-letterspacing: 0%;
    --fdt-button-sizing-minheight-normal: 40px;
    --fdt-button-sizing-minheight-small: 36px;
    --fdt-button-borderpadding-padding-horizontal: 16px;
    --fdt-button-borderpadding-padding-top: 8px;
    --fdt-button-borderpadding-gap: 8px;
    --fdt-footer-footer-links-fill: #2e3538;
    --fdt-footer-footer-links-fontfamily: Rubrik;
    --fdt-footer-footer-links-fontweight: 400;
    --fdt-footer-footer-links-lineheight: 1.5;
    --fdt-footer-footer-links-fontsize: 15px;
    --fdt-footer-footer-links-letterspacing: 0%;
    --fdt-footer-button-secondary-inverted: false;
    --fdt-footer-button-secondary: button-secondary;
    --fdt-footer-button-primary-inverted: false;
    --fdt-footer-button-primary: button-primary;
    --fdt-footer-footer-text: #2e3538;
    --fdt-footer-footer-social: #5c6970;
    --fdt-footer-up-button-inverted: false;
    --fdt-footer-footer-container-fill: #f6f9fd;
    --fdt-footer-footer-title-fontfamily: Rubrik;
    --fdt-footer-footer-title-fontweight: 500;
    --fdt-footer-footer-title-lineheight: 1.25;
    --fdt-footer-footer-title-fontsize: 21px;
    --fdt-footer-footer-title-letterspacing: 0%;
    --fdt-footer-footer-title-textcase: none;
    --fdt-footer-footer-title-fill: #2e3538;
    --fdt-footer-footer-dividers: #e1e8eb;
    --fdt-navigation-tertiary-nav-default: false;
    --fdt-navigation-tertiary-nav-brand: false;
    --fdt-navigation-tertiary-nav-dark: tertiary-nav-dark;
    --fdt-navigation-secondary-nav-default: false;
    --fdt-navigation-secondary-nav-brand: false;
    --fdt-navigation-secondary-nav-subtle: secondary-nav-subtle;
    --fdt-navigation-secondary-nav-dark: false;
    --fdt-navigation-primary-nav-default: primary-nav-default;
    --fdt-navigation-primary-nav-brand: false;
    --fdt-navigation-primary-nav-dark: false;
    --fdt-navigation-primary-nav-fontsize: 17px;
    --fdt-navigation-secondary-nav-fontsize: 17px;
    --fdt-navigation-tertiary-nav-fontsize: 13px;
    --fdt-mobile-fontsize-1: 12px;
    --fdt-mobile-fontsize-2: 14px;
    --fdt-mobile-fontsize-3: 16px;
    --fdt-mobile-fontsize-4: 18px;
    --fdt-mobile-fontsize-5: 22px;
    --fdt-mobile-fontsize-6: 24px;
    --fdt-mobile-fontsize-7: 28px;
    --fdt-mobile-fontsize-8: 32px;
    --fdt-mobile-fontsize-9: 42px;
    --fdt-mobile-fontsize-base: 16px;
    --fdt-mobile-fontsize-scale: 1.15;
    --fdt-mobile-spacing-1: 4px;
    --fdt-mobile-spacing-2: 8px;
    --fdt-mobile-spacing-3: 16px;
    --fdt-mobile-spacing-4: 24px;
    --fdt-mobile-spacing-5: 28px;
    --fdt-mobile-spacing-6: 32px;
    --fdt-mobile-spacing-7: 36px;
    --fdt-mobile-spacing-8: 40px;
    --fdt-mobile-spacing-9: 44px;
    --fdt-mobile-sizing-minheight-normal: 48px;
    --fdt-mobile-sizing-minheight-small: 44px;
  }
}
@layer fonts {
  @font-face {
    font-family: 'Rubrik';
    src: url(../../../assets/fonts/rubrik/Rubrik_Regular.woff2) format('woff2'),
      url(../../../assets/fonts/rubrik/Rubrik_Regular.woff) format('woff');
    font-weight: 400;
    font-display: swap;
  }
  @font-face {
    font-family: 'Rubrik';
    src: url(../../../assets/fonts/rubrik/Rubrik_Medium.woff2) format('woff2'),
      url(../../../assets/fonts/rubrik/Rubrik_Medium.woff) format('woff');
    font-weight: 500;
    font-display: swap;
  }
  @font-face {
    font-family: 'Rubrik';
    src: url(../../../assets/fonts/rubrik/Rubrik_SemiBold.woff2) format('woff2'),
      url(../../../assets/fonts/rubrik/Rubrik_SemiBold.woff) format('woff');
    font-weight: 600;
    font-display: swap;
  }
}
@layer settings {
  :root {
    --min-viewport: 425;
    --max-viewport: 1280;
    --mq-mob: (min-width: 40em);
    --mq-tablet: (min-width: 64em);
    --mq-until-tablet: (max-width: 63.9375em);
  }
}
@layer settings {
  @media (max-width: 39.9375em) {
    :root {
      --fdt-core-spacing-1: var(--fdt-mobile-spacing-1);
      --fdt-core-spacing-2: var(--fdt-mobile-spacing-2);
      --fdt-core-spacing-3: var(--fdt-mobile-spacing-3);
      --fdt-core-spacing-4: var(--fdt-mobile-spacing-4);
      --fdt-core-spacing-5: var(--fdt-mobile-spacing-5);
      --fdt-core-spacing-6: var(--fdt-mobile-spacing-6);
      --fdt-core-spacing-7: var(--fdt-mobile-spacing-7);
      --fdt-core-spacing-8: var(--fdt-mobile-spacing-8);
      --fdt-core-spacing-9: var(--fdt-mobile-spacing-9);
      --fdt-button-sizing-minheight-small: var(--fdt-mobile-spacing-3);
    }
  }
}
:root {
  --theme-icon--bullet: url('data:image/svg+xml,<svg transform="translate(5, 7)" transform-origin="center" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 14C12.5533 14 13.025 13.805 13.415 13.415C13.805 13.025 14 12.5533 14 12C14 11.4467 13.805 10.975 13.415 10.585C13.025 10.195 12.5533 10 12 10C11.4467 10 10.975 10.195 10.585 10.585C10.195 10.975 10 11.4467 10 12C10 12.5533 10.195 13.025 10.585 13.415C10.975 13.805 11.4467 14 12 14ZM12 16C11.4467 16 10.9267 15.895 10.44 15.685C9.95333 15.475 9.53 15.19 9.17 14.83C8.81 14.47 8.525 14.0467 8.315 13.56C8.105 13.0733 8 12.5533 8 12C8 11.4467 8.105 10.9267 8.315 10.44C8.525 9.95333 8.81 9.53 9.17 9.17C9.53 8.81 9.95333 8.525 10.44 8.315C10.9267 8.105 11.4467 8 12 8C12.5533 8 13.0733 8.105 13.56 8.315C14.0467 8.525 14.47 8.81 14.83 9.17C15.19 9.53 15.475 9.95333 15.685 10.44C15.895 10.9267 16 11.4467 16 12C16 12.5533 15.895 13.0733 15.685 13.56C15.475 14.0467 15.19 14.47 14.83 14.83C14.47 15.19 14.0467 15.475 13.56 15.685C13.0733 15.895 12.5533 16 12 16ZM12 15.2C12.8933 15.2 13.65 14.89 14.27 14.27C14.89 13.65 15.2 12.8933 15.2 12C15.2 11.1067 14.89 10.35 14.27 9.73C13.65 9.11 12.8933 8.8 12 8.8C11.1067 8.8 10.35 9.11 9.73 9.73C9.11 10.35 8.8 11.1067 8.8 12C8.8 12.8933 9.11 13.65 9.73 14.27C10.35 14.89 11.1067 15.2 12 15.2Z" fill="rgb(179, 0, 126)"/></svg>');
  --theme-icon--check: url("data:image/svg+xml,%3Csvg transform='translate(5, 6)' transform-origin='center' swidth='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 12.4908L6.40122 10.6803L10.1446 13.7862L16.2964 7L18 8.5362L10.3835 17L5 12.4908Z' fill='rgb(179, 0, 126)'/%3E%3C/svg%3E%0A");
  --theme-icon--arrowDown: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 28 20'%3E%3Cpath class='st0' d='M5.2,6.2L10,11l4.8-4.8l1.5,1.5L10,14L3.8,7.7L5.2,6.2z' fill='rgb(179, 0, 126)' /%3E%3C/svg%3E");
  --theme-icon--arrowLeft: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.35 23.65L14.7167 16L22.35 8.35L20 6L10 16L20 26L22.35 23.65Z' fill='rgb(179, 0, 126)' /%3E%3C/svg%3E%0A");
  --theme-icon--arrowRight: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.65 8.35L17.2833 16L9.65 23.65L12 26L22 16L12 6L9.65 8.35Z' fill='rgb(179, 0, 126)' /%3E%3C/svg%3E");
  --theme-icon--arrowDown-error: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 28 20'%3E%3Cpath class='st0' d='M5.2,6.2L10,11l4.8-4.8l1.5,1.5L10,14L3.8,7.7L5.2,6.2z' fill='rgb(217,38,38)' /%3E%3C/svg%3E");
  --theme-icon--arrowUp: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 28 20' %3E%3Cpath class='st0' d='M14.8,14L10,9.2L5.2,14l-1.5-1.5L10,6.2l6.2,6.2L14.8,14z' fill='rgb(179, 0, 126)' /%3E%3C/svg%3E%0A");
  --theme-icon--calendar: url('data:image/svg+xml,<svg width="32" height="33" viewBox="0 0 32 33" xmlns="http://www.w3.org/2000/svg"><path d="M16 19C15.6222 19 15.3058 18.872 15.0507 18.616C14.7947 18.3609 14.6667 18.0444 14.6667 17.6667C14.6667 17.2889 14.7947 16.972 15.0507 16.716C15.3058 16.4609 15.6222 16.3333 16 16.3333C16.3778 16.3333 16.6947 16.4609 16.9507 16.716C17.2058 16.972 17.3333 17.2889 17.3333 17.6667C17.3333 18.0444 17.2058 18.3609 16.9507 18.616C16.6947 18.872 16.3778 19 16 19ZM10.6667 19C10.2889 19 9.972 18.872 9.716 18.616C9.46089 18.3609 9.33333 18.0444 9.33333 17.6667C9.33333 17.2889 9.46089 16.972 9.716 16.716C9.972 16.4609 10.2889 16.3333 10.6667 16.3333C11.0444 16.3333 11.3613 16.4609 11.6173 16.716C11.8724 16.972 12 17.2889 12 17.6667C12 18.0444 11.8724 18.3609 11.6173 18.616C11.3613 18.872 11.0444 19 10.6667 19ZM21.3333 19C20.9556 19 20.6391 18.872 20.384 18.616C20.128 18.3609 20 18.0444 20 17.6667C20 17.2889 20.128 16.972 20.384 16.716C20.6391 16.4609 20.9556 16.3333 21.3333 16.3333C21.7111 16.3333 22.0276 16.4609 22.2827 16.716C22.5387 16.972 22.6667 17.2889 22.6667 17.6667C22.6667 18.0444 22.5387 18.3609 22.2827 18.616C22.0276 18.872 21.7111 19 21.3333 19ZM16 24.3333C15.6222 24.3333 15.3058 24.2053 15.0507 23.9493C14.7947 23.6942 14.6667 23.3778 14.6667 23C14.6667 22.6222 14.7947 22.3058 15.0507 22.0507C15.3058 21.7947 15.6222 21.6667 16 21.6667C16.3778 21.6667 16.6947 21.7947 16.9507 22.0507C17.2058 22.3058 17.3333 22.6222 17.3333 23C17.3333 23.3778 17.2058 23.6942 16.9507 23.9493C16.6947 24.2053 16.3778 24.3333 16 24.3333ZM10.6667 24.3333C10.2889 24.3333 9.972 24.2053 9.716 23.9493C9.46089 23.6942 9.33333 23.3778 9.33333 23C9.33333 22.6222 9.46089 22.3058 9.716 22.0507C9.972 21.7947 10.2889 21.6667 10.6667 21.6667C11.0444 21.6667 11.3613 21.7947 11.6173 22.0507C11.8724 22.3058 12 22.6222 12 23C12 23.3778 11.8724 23.6942 11.6173 23.9493C11.3613 24.2053 11.0444 24.3333 10.6667 24.3333ZM21.3333 24.3333C20.9556 24.3333 20.6391 24.2053 20.384 23.9493C20.128 23.6942 20 23.3778 20 23C20 22.6222 20.128 22.3058 20.384 22.0507C20.6391 21.7947 20.9556 21.6667 21.3333 21.6667C21.7111 21.6667 22.0276 21.7947 22.2827 22.0507C22.5387 22.3058 22.6667 22.6222 22.6667 23C22.6667 23.3778 22.5387 23.6942 22.2827 23.9493C22.0276 24.2053 21.7111 24.3333 21.3333 24.3333ZM6.66667 29.6667C5.93333 29.6667 5.30533 29.4058 4.78267 28.884C4.26089 28.3613 4 27.7333 4 27V8.33333C4 7.6 4.26089 6.97244 4.78267 6.45067C5.30533 5.928 5.93333 5.66667 6.66667 5.66667H8V3H10.6667V5.66667H21.3333V3H24V5.66667H25.3333C26.0667 5.66667 26.6947 5.928 27.2173 6.45067C27.7391 6.97244 28 7.6 28 8.33333V27C28 27.7333 27.7391 28.3613 27.2173 28.884C26.6947 29.4058 26.0667 29.6667 25.3333 29.6667H6.66667ZM6.66667 27H25.3333V13.6667H6.66667V27ZM6.66667 11H25.3333V8.33333H6.66667V11Z" fill="rgb(179, 0, 126)" /></svg>');
}

:root {
  --fdt-semantic-color-productattribute-height-background: #dbe9f0;
  --fdt-semantic-color-productattribute-height-border: #8fbdcc;
  --fdt-semantic-color-productattribute-fireresistance-background: #f6d5d5;
  --fdt-semantic-color-productattribute-fireresistance-border: #d92626;
  --fdt-semantic-color-productattribute-soundinsulation-background: #d1f5fa;
  --fdt-semantic-color-productattribute-soundinsulation-border: #0dccf2;
}
